import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

export const AIEmailAgentChatErrorView = ({ resetErrorBoundary }: { resetErrorBoundary: () => void }) => {
    return (
        <Stack
            height="100%"
            gap="16px"
            alignItems="flex-start"
        >
            <Text
                fontVariant="input2"
                color={colorsPalettes.carbon[500]}
                type="flat"
            >
                {translate("si.pages.ai_agent_email.error")}
            </Text>
            <IconButton
                iconName="refresh"
                onClick={resetErrorBoundary}
                type="flat"
            >
                {translate("si.common.retry")}
            </IconButton>
        </Stack>
    );
};
